/**
 * Coup de pouce — Attendu 1111 « tester si une égalité est vraie pour une
 * valeur de la lettre » (automatisme 4e, l. 708). UNE page PAS À PAS (trois
 * temps) partagée par les quatre generator_keys : le geste en entier sur un
 * exemple, et la phrase qui couvre le cas faux (les cartes Vrai/Faux
 * mélangent les deux).
 *
 * L'image que l'élève a déjà : les lignes qui s'alignent sous le signe égal
 * (1106), la lettre remplacée par sa valeur (1108 : « 3x, c'est 3 × x »).
 * Temps 1 : « Pour x = 4, est-ce que 3x + 2 = 14 ? », le x en orange, la
 * valeur 4 à côté. Temps 2 : je remplace, « 3 × 4 + 2 = 12 + 2 = 14 ».
 * Temps 3 : « 14 = 14 : oui. » ; « Je remplace x par 4, je calcule à
 * gauche : 14. » ; « C'est bien 14 : l'égalité est vraie pour x = 4. » ;
 * « Si je n'avais pas trouvé 14, elle serait fausse. » Même calcul que 1106
 * (la multiplication d'abord).
 *
 * SACRIFIÉ : (3x + 2 ; x = 4) quel que soit le membre droit (gen_1111,
 * SACRIFIE, auto-testé par gen1111.self.test.js). Largeur bornée à 340 px,
 * tailles de 1048.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const VERT = '#15803D';
const ENCRE = '#1E293B';

/** La lettre, dans la police italique de KaTeX (déclarée par katex.min.css) : le même x que dans les énoncés. */
const X = `<tspan font-family="KaTeX_Math, 'Times New Roman', serif" font-style="italic">x</tspan>`;

const SVG_TEST = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 262" width="100%" style="max-width:340px;height:auto;display:block" role="img" data-etapes="3"
     aria-label="Pour x égale 4, est-ce que 3 x plus 2 égale 14 ? Temps 1 : le x est en orange, et à côté, dans un cadre orange, x égale 4. Temps 2 : je remplace x par 4 : 3 fois 4 plus 2 égale 12 plus 2 égale 14. Temps 3 : 14 égale 14, oui. Je remplace x par 4, je calcule à gauche : 14. C'est bien 14 : l'égalité est vraie pour x égale 4. Si je n'avais pas trouvé 14, elle serait fausse.">
  <text x="200" y="30" font-size="16" font-weight="bold" text-anchor="middle" fill="${ENCRE}">Pour <tspan fill="${ORANGE}">${X} = 4</tspan>, est-ce que <tspan fill="${BLEU}">3${X} + 2</tspan> = 14 ?</text>

  <!-- temps 1 : la lettre et sa valeur -->
  <g data-etape="1">
    <text x="150" y="82" font-size="22" font-weight="bold" text-anchor="middle" fill="${BLEU}">3<tspan fill="${ORANGE}">${X}</tspan> + 2</text>
    <rect x="236" y="60" width="72" height="32" rx="8" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
    <text x="272" y="82" font-size="16" font-weight="bold" text-anchor="middle" fill="${ORANGE}">${X} = 4</text>
  </g>

  <!-- temps 2 : je remplace, je calcule -->
  <g data-etape="2">
    <text x="200" y="130" font-size="20" font-weight="bold" text-anchor="middle" fill="${ENCRE}"><tspan fill="${BLEU}">3 × </tspan><tspan fill="${ORANGE}">4</tspan><tspan fill="${BLEU}"> + 2</tspan> = 12 + 2 = <tspan fill="${VERT}">14</tspan></text>
  </g>

  <!-- temps 3 : la comparaison, le geste, le cas faux -->
  <g data-etape="3">
    <text x="200" y="170" font-size="20" font-weight="bold" text-anchor="middle" fill="${VERT}">14 = 14 : oui.</text>
    <text x="200" y="206" font-size="12" text-anchor="middle" fill="${ENCRE}">Je remplace <tspan font-weight="bold" fill="${ORANGE}">${X}</tspan> par <tspan font-weight="bold" fill="${ORANGE}">4</tspan>, je calcule à gauche : <tspan font-weight="bold" fill="${VERT}">14</tspan>.</text>
    <text x="200" y="228" font-size="12" text-anchor="middle" fill="${ENCRE}">C'est bien 14 : l'égalité est vraie pour ${X} = 4.</text>
    <text x="200" y="250" font-size="12" text-anchor="middle" fill="${ENCRE}">Si je n'avais pas trouvé 14, elle serait fausse.</text>
  </g>
</svg>`.trim();

const AIDE = { pages: [{ titre: 'Je remplace, je calcule', svg: SVG_TEST }] };

const CP_1111 = {
    test_tableau_vf: AIDE,
    substitution_qcm_unique: AIDE,
    vraie_qcm_unique: AIDE,
    geste_texte_trou_drag: AIDE,
};

export default CP_1111;
